<template>
	<div class="c-goods">
		<div v-if="index" class="c-goods-index flex-center">{{index}}</div>
		<p class="c-goods-title">{{title}}</p>
		<p class="c-goods-info flex-wrap">
			<template v-for="(item, i) in info">
				<ins v-if="i">|</ins>
				<span :key="i">{{item}}</span>
			</template>
		</p>
		<p class="c-goods-info">备注：{{remark}}</p>
	</div>
</template>

<script>
	export default {
		name: 'goodsCard',

		props: {
			index: [Number, String],
			title: String,
			info: Array,
			remark: String
		}
	}
</script>

<style lang="stylus" scoped>
	.c-goods {
		position: relative;
		border-radius: .16rem;
		padding: .42rem .36rem .2rem;
		background: #F9F9F9;

		&:nth-child(n+2) {
			margin-top: .16rem;
		}

		&-index {
			position: absolute;
			left: 0;
			top: 0;
			box-sizing: border-box;
			min-width: .4rem;
			height: .4rem;
			padding: 0 .1rem;
			border-radius: .16rem 0 .16rem 0;
			margin-right: .14rem;
			margin-top: -.02rem;
			font-size: .28rem;
			text-align: center;
			color: #00ACA9;
			background: #E8F5F5;
		}

		&-title {
			margin-bottom: .1rem;
			line-height: .46rem;
			font-size: .3rem;
			color: var(--color-main);
		}

		&-info {
			line-height: .46rem;
			font-size: .26rem;
			color: #999;

			ins {
				margin: 0 .5em;
			}
		}
	}
</style>
